import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, clsx, RelativeTime, Text, useStayScrolledToBottom, } from '@a-type/ui';
import { useGameSuite, withGame } from '@long-game/game-client';
import { Suspense } from 'react';
import { useRendererContext } from '../RendererProvider.js';
import cls from './ChatLog.module.css';
export const ChatLog = withGame(function ChatLog({ gameSuite, log, className, ...props }) {
    const { ChatRendererComponent: ChatRenderer } = useRendererContext();
    const items = [];
    let startRoundIndex = -1;
    for (let i = 0; i < log.length; i++) {
        const entry = log[i];
        if (entry.type === 'chat') {
            startRoundIndex = -1; // Reset round index when encountering a chat message
            const next = log[i + 1];
            const previous = log[i - 1];
            const nextMessage = next?.type === 'chat' ? next.chatMessage : null;
            const previousMessage = previous?.type === 'chat' ? previous.chatMessage : null;
            items.push(_jsx(Suspense, { children: _jsx(ChatRenderer, { message: entry.chatMessage, nextMessage: nextMessage, previousMessage: previousMessage, compact: false }) }, entry.chatMessage.id));
        }
        else {
            if (startRoundIndex === -1) {
                startRoundIndex = entry.roundIndex;
            }
            if (log[i + 1]?.type === 'round') {
                continue;
            }
            items.push(_jsx(RoundBoundary, { startIndex: startRoundIndex, endIndex: entry.roundIndex }, `round-${entry.roundIndex}`));
        }
    }
    const scrollProps = useStayScrolledToBottom();
    return (_jsx(Box, { grow: true, container: true, overflow: "auto-y", full: true, gap: "xs", col: true, items: "stretch", className: clsx(cls.root, className), "data-testid": "game-log", ...props, ...scrollProps, children: items }));
});
function RoundBoundary({ startIndex, endIndex, }) {
    const gameSuite = useGameSuite();
    const roundLabelStart = gameSuite.gameDefinition.getRoundLabel?.({
        roundIndex: startIndex,
        members: gameSuite.members,
    });
    const roundLabelEnd = gameSuite.gameDefinition.getRoundLabel?.({
        roundIndex: endIndex,
        members: gameSuite.members,
    });
    return (_jsxs(Box, { full: "width", items: "center", dim: true, className: "@mode-denser", children: [_jsx("div", { className: cls.line }), _jsxs("div", { className: cls.dividerText, children: [roundLabelStart ?? `Round ${startIndex + 1}`, startIndex !== endIndex && roundLabelEnd && (_jsxs(_Fragment, { children: [" - ", roundLabelEnd ?? `Round ${endIndex + 1}`] }))] }), _jsx("div", { className: cls.line })] }));
}
export function ChatLogTimestamp({ value }) {
    return (_jsx(Text, { emphasis: "ambient", dim: true, italic: true, className: cls.timestamp, children: _jsx(RelativeTime, { value: new Date(value).getTime() }) }));
}
//# sourceMappingURL=ChatLog.js.map